module.exports = __webpack_public_path__ + "static/media/shiksha.6cc137d0.png";